import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "bg-white mx-2 md:mx-0 px-10 py-8 rounded-xl w-screen shadow-md max-w-md" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-4 mb-12" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center text-5xl font-semibold text-gray-600" }, "Galia")
], -1)
const _hoisted_3 = {
  key: 0,
  class: "-mt-4"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Login with Microsoft", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.messages.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message) => {
            return (_openBlock(), _createElementBlock("div", {
              key: message,
              class: "p-4 mb-4 text-sm text-yellow-700 bg-yellow-100 rounded-md",
              role: "alert"
            }, _toDisplayString(message), 1))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_app_button, {
      onClick: _ctx.onMicrosoftLoginClick,
      type: "blue",
      class: _normalizeClass(['w-full text-lg font-normal leading-normal'])
    }, {
      default: _withCtx(() => [
        _hoisted_4
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}